import React, { ReactNode } from "react";

import StandardHeader, {
  StandardHeaderProps,
} from "@app/components/molecules/StandardHeader";

type StandardTemplateProps = {
  children: ReactNode;
} & StandardHeaderProps;

const StandardTemplate = ({
  children,
  title,
  primaryButton,
  helperText,
  secondaryButton,
  showBackButton,
  buttonOptions,
  onBackButton,
}: StandardTemplateProps) => (
  <>
    <StandardHeader
      title={title}
      helperText={helperText}
      primaryButton={{
        ...primaryButton,
      }}
      onBackButton={onBackButton}
      secondaryButton={{ ...secondaryButton }}
      buttonOptions={buttonOptions}
      showBackButton={showBackButton}
    />
    {children}
  </>
);

export default StandardTemplate;
